export default {
  button: {
    toMainPage: "Басты бет",
    login: "Кіру",
    registration: "Тіркелу",
    back: "Артқа",
    rcGroupWiki: "RC Group Wiki",
  },
  title: "Авторизация",
  pageTab: {
    owner: "Иесі",
    manager: "Менеджер",
  },
  form: {
    country: "Ел",
    mail: "Пошта",
    login: "Логин",
    password: "Пароль",
    repeatPass: "Парольді қайталаңыз",
    minInputSize: "Кем дегенде {size} таңбадан тұруы керек",
  },
  noAccount: "Аккаунт жоқ па?",
  forgotPassword: "Парольді ұмыттыңыз ба?",
  dontWorryAboutForgotPass:
    "Уайымдамаңыз, біз сізге поштаға қалпына келтіру сілтемесін жібереміз",

  resetPass: {
    dontWorry:
      "Уайымдамаңыз, біз сізге поштаға қалпына келтіру сілтемесін жібереміз",
    info: {
      title: "Кіру туралы ақпарат поштаңызға жіберілді",
      sendedLink: "Біз парольді өзгерту сілтемесін поштаға жібердік",
      checkSpam: "Хат алмаған болсаңыз, «Спам» бумасын тексеріңіз",
    },
    resendMail: "Хатты 00:%{timer} өткен соң қайта жіберу",
    messageNotReceived: "Хат келмеді ме?",
    title: "Парольді өзгерту",
    enterNewPass: "Жеке кабинетке кіру үшін қолданатын жаңа парольді енгізіңіз",
  },
};
